import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; // If you're using location
import moment from "moment";
import axios from "axios";
import APP_BASE_URL from "../../components/Api/globalApi";
import { ThreeDots } from "react-loader-spinner";
import { Button, FormGroup, FormControl } from "react-bootstrap";

const Activation = ({ details, index }) => {
  const [selectedAmount, setSelectedAmount] = useState("");

  const handleAmountChange = (u_id, value) => {
    setSelectedAmount((prev) => ({
      ...prev,
      [u_id]: value,
    }));
  };

  // Retrieve the user_id from localStorage
  const storedUserId = localStorage.getItem("user_id");

  // State for user history
  const [userhistory, setUserhistory] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state for better UX
  const [error, setError] = useState(null); // Error state
  const [showActivatedList, setShowActivatedList] = useState(false);
  const [activatedList, setActivatedList] = useState([]);

  // Fetch user withdrawal history on component mount
  useEffect(() => {
    // fetchUserHistory();
  }, []);

  const [userlogin, setUserlogin] = useState(null);
  const [loadinghis, setLoadinghis] = useState(true); // Loading state for better UX

  const fetchUserHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(
        ` ${APP_BASE_URL}/user/activation/list`,
        { ref_id: searchTerm }, // Send the appropriate data if necessary in the request body
        {
          headers: {
            user_id: "1", // Pass the user_id in headers
          },
        }
      );

      // Set the fetched data in state
      setUserhistory(response.data.list);
      setShowActivatedList(false);
    } catch (error) {
      setError("Error fetching data. Please try again."); // Set error message
      console.error("Error fetching user history:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserActivatedHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(
        `${APP_BASE_URL}/user/activated/list`,
        {}, // Send the appropriate data if necessary in the request body
        {
          headers: {
            user_id: storedUserId, // Pass the user_id in headers
          },
        }
      );

      // Set the fetched data in state
      setActivatedList(response.data.data);
      setShowActivatedList(true); // Switch to show activated users
    } catch (error) {
      setError("Error fetching data. Please try again."); // Set error message
      console.error("Error fetching user history:", error);
    } finally {
      setLoading(false);
    }
  };

  const Activation = async (u_id) => {
    setUserlogin(u_id);
    try {
      const response = await axios.post(
        `${APP_BASE_URL}/user/status-update/activation`,

        { user_id: u_id, status: "active", amount: selectedAmount[u_id] }, // Send the appropriate data if necessary in the request body
        {
          headers: {
            u_id: storedUserId, // Pass the user_id in headers
          },
        }
      );

      console.log(selectedAmount[u_id], "selectedAmount");
      if (response.data.result === true) {
        alert(response.data.message);
        fetchUserHistory();
      } else alert(response.data.message);
    } catch (error) {
      console.error("Error activating user:", error);
    } finally {
      setUserlogin(null);
    }
  };

  //search
  const [searchTerm, setSearchTerm] = useState(null);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <div className="container-fluid myprofile py-5">
        <div className="mb-5">
          <FormGroup className="d-flex ">
            <FormControl
              type="text"
              className="w-100"
              placeholder="Search Your ID"
              value={searchTerm}
              onChange={handleSearchChange}
            />

            <Button
              className="ms-4 w-100 border border-1"
              onClick={fetchUserHistory}
            >
              Search
            </Button>

            <Button
              className="ms-4 w-100 border border-1"
              onClick={fetchUserActivatedHistory}
            >
              Activated List
            </Button>
          </FormGroup>
        </div>
        {loading ? (
          <div className="mt-5 text-center justify-content-center align-items-center">
            Please wait...
            <div className="justify-content-center align-items-center d-flex">
              <ThreeDots color="#00BFFF" height={20} width={50} />
            </div>
          </div>
        ) : error ? (
          <div>{error}</div>
        ) : (
          <>
            {!showActivatedList ? (
              <>
                <div className="addwallet">
                  <h4 className="text-white ">Activation List</h4>
                </div>

                <div className="table-responsive mt-4">
                  <table className="table table-light table-hover shadow">
                    <thead>
                      <tr>
                        <th scope="col">Sl no</th>
                        <th scope="col">Name </th>
                        <th scope="col">Referral ID</th>
                        <th scope="col">Date</th>
                        <th scope="col">Purchase Amount</th>
                        <th scope="col">Activation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userhistory?.length > 0 ? (
                        userhistory.map((details, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{details.u_first_name}</td>
                            <td>{details.u_referal_id}</td>
                            <td>
                              {moment(details.u_joining_date).format(
                                "DD MMM YYYY"
                              )}
                            </td>
                            <td>
                              <select
                                className="form-select"
                                onChange={(e) =>
                                  handleAmountChange(
                                    details.u_id,
                                    e.target.value
                                  )
                                }
                                value={selectedAmount[details.u_id] || ""}
                              >
                                <option value="First">
                                  Please Select Amount
                                </option>
                                <option value="150">150</option>
                                <option value="190">190</option>
                                <option value="340">340</option>
                                <option value="500">500</option>
                                <option value="540">540</option>
                                <option value="580">580</option>
                                <option value="999">999</option>
                              </select>
                            </td>
                            <td className="text-capitalize">
                              {selectedAmount[details.u_id] ? (
                                <Button
                                  variant="primary"
                                  onClick={() => Activation(details.u_id)}
                                >
                                  {userlogin === details.u_id ? (
                                    <>
                                      <ThreeDots
                                        color="#00BFFF"
                                        height={20}
                                        width={50}
                                      />
                                      Activating...
                                    </>
                                  ) : (
                                    <div className="text-capitalize">
                                      {details.u_status}
                                    </div>
                                  )}
                                </Button>
                              ) : null}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <>
                <div className="addwallet">
                  <h4 className="text-white ">Activated List</h4>
                </div>

                <div className="table-responsive mt-4">
                  <table className="table table-light table-hover shadow">
                    <thead>
                      <tr>
                        <th scope="col">Sl no</th>
                        <th scope="col">Name </th>
                        <th scope="col">Referral ID</th>
                        <th scope="col">Date</th>
                        <th scope="col">Purchase Amount</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activatedList?.length > 0 ? (
                        activatedList.map((details, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{details.u_first_name}</td>
                            <td>{details.u_referal_id}</td>
                            <td>
                              {moment(details.u_joining_date).format(
                                "DD MMM YYYY"
                              )}
                            </td>
                            <td>{details.u_first_purchase}</td>
                            <td>{details.u_status}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No activated users found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Activation;
